/**
 * Die fachliche Meldung aus einem Apollo-Fehler ziehen.
 *
 * Hintergrund: Ankuendigungen werden serverseitig gegen eine Allow-List geprueft, und die
 * Meldung nennt Sprachtag und Knotentyp — „Ankuendigungstext (en): nicht erlaubter Knoten im
 * Body: table". Das Client-Dok §8.1 sagt ausdruecklich, dass diese Meldung dem Autor gezeigt
 * gehoert und nicht nur geloggt. Sind mehrere Sprachfassungen betroffen, kommt EINE Meldung
 * mit „; " verkettet.
 */
export function serverErrorMessages(error: unknown): string[] {
  const candidate = error as { graphQLErrors?: { message?: string }[]; message?: string } | null;
  const raw = candidate?.graphQLErrors?.[0]?.message ?? candidate?.message ?? '';
  // Die Typisierung sagt string, aber der Wert kommt von aussen (ein Apollo-Fehlerobjekt) —
  // ohne die Wache riesse ein nicht-stringiges message (oder gar keins) den split() hier
  // hinein, und das faellt innerhalb eines error-Callbacks: der Handler bricht komplett ab.
  if (typeof raw !== 'string') {
    return [];
  }
  return raw
    .split('; ')
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}
